import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenu = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 2.40002,
			y: 4.8,
			width: 23.2,
			height: 2.4,
			rx: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2.40002,
			y: 12.8,
			width: 23.2,
			height: 2.4,
			rx: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2.40002,
			y: 20.8,
			width: 23.2,
			height: 2.4,
			rx: 1.2
		})
	]
});
export { SvgMenu as ReactComponent };
